<p-card>
  <ng-template pTemplate="header"> </ng-template>
  <p-table [value]="deliveryDays" dataKey="id" class="table-sm" [tableStyle]="{ 'min-width': '50rem', 'width': '50vw' }">
    <ng-template #header>
      <tr>
        <th>Day</th>
        <th>Active</th>
        <th>Last Action</th>
      </tr>
    </ng-template>
    <ng-template #body let-deliveryDay let-ri="rowIndex">
      <tr>
        <td>
          {{ deliveryDay.day }}
        </td>
        <td>
          <p-toggleswitch
            [(ngModel)]="deliveryDay.isActive"
            (change)="tglDeliveryDay(deliveryDay)"
            attr.data-testid="tglDeliveryDay{{ deliveryDay.day }}" />
        </td>
        <td>
          <app-audit-info [value]="deliveryDay" [direction]="'horizontal'"></app-audit-info>
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-card>
